import React from 'react'
import header_image from '../assets/header_image.jpg';

export default function Header() {
  return (
    <div>
      <img src={header_image} alt="header_image" />
    </div>
  )
}
